export default __webpack_public_path__ + "static/20250731-4216c5bdbeccecd93593c3c72a3fc573.png";